export default {
  mobile: '(max-width: 767px)',
  tablet: '(min-width: 768px) and (max-width: 991px)',
  desktop: '(min-width: 992px) and (max-width: 1200px)',
  jumbo: '(min-width: 1201px)',
  desktopOrJumbo: '(min-width: 992px)',

  // Corresponds to Bootstrap 4 breakpoints
  extraSmall: '(max-width: 543px)',
  small: '(min-width: 544px) and (max-width: 767px)',
  medium: '(min-width: 768px) and (max-width: 991px)',
  large: '(min-width: 992px) and (max-width: 1199px)',
  extraLarge: '(min-width: 1200px)',

  smallDown: '(max-width: 767px)',
  mediumUp: '(min-width: 768px)',
  mediumDown: '(max-width: 991px)',
  largeUp: '(min-width: 992px)',
};
